// @flow

import * as React from "react"
import Modal from "react-modal"
import {withTranslation} from "react-i18next"
import {connect} from "react-redux"
import ClassNames from "classnames"

import Toggle from "../toggle"
import {post, get} from "../../client"
import Config from "../../config"
import {updateShopItem} from "../../actions/shop"
import {toDinero} from "../../util"
import type {
  State as ReduxState,
  Dispatch,
  ShopItem,
  ShopItemContents,
  SearchItem,
} from "../../types"

type Props = {
  +t: any,
  +item: ShopItem,
  +searchItems: $ReadOnlyArray<SearchItem>,
  +babyToken: string,
  +dispatch: Dispatch,
  +onClose: () => void,
}

type Error = {
  +field: string,
  +message: string,
}

// +shopItems: $ReadOnlyArray<ShopItem>,
type State = {
  +item: any,
  +contents: ?ShopItemContents,
  +searchItems: $ReadOnlyArray<SearchItem>,
  +errors: $ReadOnlyArray<Error>,
  +calculatedPriceSelling: string,
  +calculatedOrderCost: string,
}

class ShopAdminItemModal extends React.Component<Props, State> {
  handleSave: (SyntheticEvent<*>) => void
  handlePublishToggle: () => void
  handleStickyToggle: () => void
  handleInputChange: (
    SyntheticInputEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => void
  handlePartsChange: (
    SyntheticInputEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => void

  // handleRemoveItemFromGroup: ShopBabyListItem => void
  // handleAddItemToGroup: SearchItem => void

  constructor(props: Props) {
    super(props)

    Modal.setAppElement("#app")

    this.state = {
      item: {
        ...props.item,
      },
      searchItems: [...props.searchItems],
      contents: null,
      errors: [],
      calculatedPriceSelling: "",
      calculatedOrderCost: "",
    }

    this.handleSave = this.handleSave.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handlePartsChange = this.handlePartsChange.bind(this)
    this.handlePublishToggle = this.handlePublishToggle.bind(this)
    this.handleStickyToggle = this.handleStickyToggle.bind(this)

    // this.handleAddItemToGroup = this.handleAddItemToGroup.bind(this)
    // this.handleRemoveItemFromGroup = this.handleRemoveItemFromGroup.bind(this)
  }

  componentDidMount() {
    const {
      babyToken,
      item: {id},
    } = this.props
    get(`/babies/${babyToken}/shop/${id}/contents`).then((response) => {
      this.setState({contents: response.data})
    })
  }

  handleInputChange(
    e: SyntheticInputEvent<HTMLTextAreaElement | HTMLInputElement>
  ) {
    this.setState({
      item: {
        ...this.state.item,
        [e.currentTarget.name]: e.currentTarget.value,
      },
    })
  }

  handlePartsChange(
    e: SyntheticInputEvent<HTMLTextAreaElement | HTMLInputElement>
  ) {
    const {
      babyToken,
      item: {id},
    } = this.props
    const parts = parseInt(e.currentTarget.value)

    this.handleInputChange(e)

    post(`/babies/${babyToken}/shop/${id}/calculate/parts`, {
      parts,
    }).then((response) => {
      this.setState({
        calculatedPriceSelling: response.data.priceSelling,
        calculatedOrderCost: response.data.orderCost,
      })
    })
  }

  handleSave(e: any) {
    const {item} = this.state
    const {dispatch, babyToken, onClose} = this.props
    const {
      nameNl,
      descriptionNl,
      nameFr,
      descriptionFr,
      nameEn,
      descriptionEn,
      parts,
    } = item
    let errors = []
    /* if (nameNl.length == 0) {
      errors.push({
        field: "name",
        message: "Name NL is required",
      })
    } */

    if (errors.length == 0) {
      dispatch(
        updateShopItem(
          babyToken,
          item.id,
          nameNl,
          descriptionNl,
          nameFr,
          descriptionFr,
          nameEn,
          descriptionEn,
          parts,
          item.isPublished,
          item.isSticky
        )
      )
      onClose()
    } else {
      e.preventDefault()
      this.setState({errors})
      return false
    }
  }

  handlePublishToggle() {
    this.setState({
      item: {
        ...this.state.item,
        isPublished: !this.state.item.isPublished,
      },
    })
  }

  handleStickyToggle() {
    this.setState({
      item: {
        ...this.state.item,
        isSticky: !this.state.item.isSticky,
      },
    })
  }

  // handleAddItemToGroup(item: ShopBabyListItem) {
  //   const {item: stateItem, itemsToSell: stateItemsToSell} = this.state
  //   this.setState({
  //     item: { ...stateItem, items: sortBy([...stateItem.items, item], i => i.id), },
  //     itemsToSell: sortBy( stateItemsToSell.filter(i => i.id !== item.id), i => i.id),
  //   })
  // }

  // handleRemoveItemFromGroup(item: ShopBabyListItem) {
  //   const {item: stateItem, itemsToSell: stateItemsToSell} = this.state
  //   this.setState({
  //     item: { ...stateItem, items: sortBy(stateItem.items.filter(i => i.id !== item.id), i => i.id), },
  //     itemsToSell: sortBy([...stateItemsToSell, item], i => i.id),
  //   })
  // }

  // renderGroupInputs() {
  //   const {t} = this.props
  //   const {item, itemsToSell} = this.state
  //   return (
  //     <>
  //       <div className="form-group">
  //         <label htmlFor="items">{t('shopAdmin.group.items')}</label>
  //         <div>
  //           <ul>
  //             {item.items.map(babyListItem => {
  //               return (
  //                 <li
  //                   key={`group-edit-group-item-${babyListItem.id}`}
  //                   className="d-flex justify-content-between">
  //                   {babyListItem.name}
  //                   <button
  //                     className="btn btn-icon"
  //                     type="button"
  //                     onClick={() =>
  //                       this.handleRemoveItemFromGroup(babyListItem)
  //                     }>
  //                     <Icon name="icon-trash" />
  //                   </button>
  //                 </li>
  //               )
  //             })}
  //           </ul>
  //         </div>
  //       </div>
  //       <div className="form-group">
  //         <label htmlFor="items">{t('shopAdmin.group.moreItems')}</label>
  //         <div>
  //           <ul>
  //             {itemsToSell.map(babyListItem => {
  //               return (
  //                 <li
  //                   key={`group-edit-sellable-item-${babyListItem.id}`}
  //                   className="d-flex justify-content-between">
  //                   {babyListItem.name}
  //                   <button
  //                     className="btn btn-icon"
  //                     type="button"
  //                     onClick={() => this.handleAddItemToGroup(babyListItem)}>
  //                     <Icon name="icon-plus" />
  //                   </button>
  //                 </li>
  //               )
  //             })}
  //           </ul>
  //         </div>
  //       </div>
  //     </>
  //   )
  // }

  renderParts() {
    const {t} = this.props
    const {item} = this.state

    if (item.type != "single" && item.type != "group") {
      return (
        <div className="form-group">
          <div className="row">
            <div className="col-sm-6">
              {item.amount} {t("shopAdmin.items")}
            </div>
            <div className="col-sm-6">
              {toDinero(item.priceSelling)
                .add(toDinero(item.orderCost))
                .toFormat("$0,0.00")}
            </div>
          </div>
        </div>
      )
    }

    const {calculatedPriceSelling, calculatedOrderCost} = this.state
    const priceSelling = calculatedPriceSelling.length
      ? calculatedPriceSelling
      : item.priceSelling
    const orderCost = calculatedOrderCost.length
      ? calculatedOrderCost
      : item.orderCost

    return (
      <div className="form-group">
        <div className="row">
          <div className="col-sm-6">
            <select
              className="form-control w-25 d-inline-block mr-2"
              name="parts"
              value={item.parts}
              onChange={this.handlePartsChange}
            >
              {[...Array(26).keys()].slice(1).map((f) => (
                <option key={f} value={f}>
                  {f}
                </option>
              ))}
            </select>{" "}
            {t("shopAdmin.parts").toLowerCase()}
          </div>
          <div className="col-sm-6 pt-2">
            {toDinero(priceSelling)
              .add(toDinero(orderCost))
              .toFormat("$0,0.00")}{" "}
            {t("shopAdmin.perPart")}
          </div>
        </div>
      </div>
    )
  }

  renderPublishedToggle() {
    const {t} = this.props
    const {item} = this.state
    const labelL = t("shopAdmin.published")
    const labelR = t("shopAdmin.unpublished")
    const optL = {label: labelL, value: 1}
    const optR = {label: labelR, value: 0}
    return (
      <div className="mb-4">
        <Toggle
          optL={optL}
          optR={optR}
          selected={item.isPublished ? 1 : 0}
          onToggle={this.handlePublishToggle}
        />
      </div>
    )
  }

  renderStickyToggle() {
    const {t} = this.props
    const {item} = this.state
    const labelL = t("shopAdmin.sticky")
    const labelR = t("shopAdmin.unsticky")
    const optL = {label: labelL, value: 1}
    const optR = {label: labelR, value: 0}
    return (
      <div className="mb-4">
        <Toggle
          optL={optL}
          optR={optR}
          selected={item.isSticky ? 1 : 0}
          onToggle={this.handleStickyToggle}
        />
      </div>
    )
  }

  renderContents() {
    const {t} = this.props
    const {contents} = this.state
    if (!contents || !contents.products.length) {
      return null
    }
    return (
      <div className="mb-4">
        <label>{t("shopAdmin.itemContents")}</label>
        <br />
        {contents.products.map((p) => p.name).join(", ")}.
      </div>
    )
  }

  renderBody() {
    const {t} = this.props
    const {errors, item} = this.state
    const formClassName = ClassNames("needs-validation", {
      "was-validated": errors.length > 0,
    })
    return (
      <form
        noValidate={true}
        className={formClassName}
        onSubmit={this.handleSave}
      >
        <div className="form-group">
          <label htmlFor="name">{t("shopAdmin.modal.name")} NL</label>
          <input
            id="nameNl"
            className="form-control"
            value={item.nameNl}
            required={true}
            autoFocus={true}
            onChange={this.handleInputChange}
            name="nameNl"
          />
        </div>
        <div className="form-group">
          <label htmlFor="description">
            {t("shopAdmin.modal.description")} NL
          </label>
          <textarea
            className="form-control"
            id="descriptionNl"
            name="descriptionNl"
            required={true}
            maxLength={5000}
            onChange={this.handleInputChange}
            value={item.descriptionNl}
          />
        </div>
        <div className="form-group">
          <label htmlFor="name">{t("shopAdmin.modal.name")} FR</label>
          <input
            id="nameFr"
            className="form-control"
            value={item.nameFr}
            required={true}
            autoFocus={true}
            onChange={this.handleInputChange}
            name="nameFr"
          />
        </div>
        <div className="form-group">
          <label htmlFor="description">
            {t("shopAdmin.modal.description")} FR
          </label>
          <textarea
            className="form-control"
            id="descriptionFr"
            name="descriptionFr"
            required={true}
            maxLength={5000}
            onChange={this.handleInputChange}
            value={item.descriptionFr}
          />
        </div>
        <div className="form-group">
          <label htmlFor="name">{t("shopAdmin.modal.name")} EN</label>
          <input
            id="nameEn"
            className="form-control"
            value={item.nameEn}
            required={true}
            autoFocus={true}
            onChange={this.handleInputChange}
            name="nameEn"
          />
        </div>
        <div className="form-group">
          <label htmlFor="description">
            {t("shopAdmin.modal.description")} EN
          </label>
          <textarea
            className="form-control"
            id="descriptionEn"
            name="descriptionEn"
            required={true}
            maxLength={5000}
            onChange={this.handleInputChange}
            value={item.descriptionEn}
          />
        </div>
        {errors.length > 0 && (
          <div className="errors mb-4">
            {errors.map((error, idx) => (
              <div key={`error-${idx}`} className="text-danger">
                {error.message}
              </div>
            ))}
          </div>
        )}
        {this.renderParts()}
        <div className="row">
          <div className="col-6">{this.renderPublishedToggle()}</div>
          <div className="col-6">{this.renderStickyToggle()}</div>
        </div>
        {this.renderContents()}
        <button className="btn btn-primary" type="submit">
          {t(`shopAdmin.modal.save`)}
        </button>
      </form>
    )
  }

  render() {
    const {t, onClose} = this.props
    return (
      <Modal
        className="modal-dialog"
        isOpen={true}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        onRequestClose={onClose}
        contentLabel=""
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {t(`shopAdmin.${this.state.item.type}.title`)}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label={t("modal.close")}
              onClick={onClose}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div className="modal-body pt-0">{this.renderBody()}</div>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state: ReduxState) => ({
  searchItems: state.shop.searchItems,
  babyToken: Config.data.babyToken,
})

export default withTranslation()(connect(mapStateToProps)(ShopAdminItemModal))
